import { Fragment } from "react";
import { FiltersProvider } from "../../../components/providers/FiltersProvider";
import PageHeader from "../../../layout/shared/page-header";
import { menuRoutes } from "../../../router/menu";
import UsersRankingsList from "./UsersRankingsList";

const UsersRankingsListWrapper = () => {

    const breadCrumb = [
        { name: 'Ventas' },
        { name: 'Gestión de contratos' },
        { name: 'Rankings de usuarios', href: menuRoutes.userRankings.path },
    ];

    return (
        <Fragment>
            <FiltersProvider>
                <PageHeader title="Listado de rankings de usuarios" breadcrumb={breadCrumb} />
                <UsersRankingsList />
            </FiltersProvider>
        </Fragment>
    );
}

export default UsersRankingsListWrapper;